import { useTranslation } from 'react-i18next';
import type { DiaEvolucion } from '@/lib/liquidacion-evolucion';

export function EvolucionAvisos({ dia }: { dia: DiaEvolucion }) {
  const { t } = useTranslation();
  return (
    <div className="space-y-2 text-sm text-text-secondary">
      {dia.causas.length > 0 && (
        <ul className="list-inside list-disc">
          {dia.causas.map((c) => (
            <li key={c}>{t(`evolucion.causas.${c}`)}</li>
          ))}
        </ul>
      )}
      {dia.advertencias
        .filter((a) => a !== 'pienso_entregado_no_consumo')
        .map((a) => (
          <p key={a}>{t(`evolucion.avisos.${a}`, { count: dia.partes_pendientes })}</p>
        ))}
    </div>
  );
}
